var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('img',{staticStyle:{"height":"18px","marign-right":"4px","vertical-align":"middle"},attrs:{"src":"http://img.yunduanbian.cn:9000/crm-client/beidou/icon_flag/tel_green.png","alt":""}}),_vm._v("\n    "+_vm._s(_vm.userInfo)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d2ed8c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/render-components/render-phone.vue
// module id = null
// module chunks = 